import React, { useEffect, useState } from "react";
import ProfileTable from "../../components/Profile/ProfileTable";
import { getReportsByUser } from "../../services/reports";
import { Typography, Card, Tag } from "antd";
import { useAuth } from "../../contexts/AuthContext";
import subscriptionService from "../../services/subscriptionService";


const { Title, Text } = Typography;


const Profile = () => {
  const { user, refreshUser } = useAuth();
  const [pdfs, setPdfs] = useState([]);
  const [pdfCount, setPdfCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
    total: 0,
  });
  const[update,setUpdate]=useState(false);

  const subscriptionColorMap = {
    active: "green",
    inactive: "default",
    past_due: "orange",
    cancelled: "red",
  };

  const fetchReports = async (page = 1, pageSize = 5) => {
    try {
      setLoading(true);
      const response = await getReportsByUser(page);
      if (response.success) {
        setPdfs(response.data);
        setPagination({
          current: page,
          pageSize,
          total: response.total,
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    const syncAndFetch = async () => {
      const authData = JSON.parse(localStorage.getItem("authData") || "{}");
      const token = authData?.token;

      if (token && user?.stripeSubscriptionId && !user?.currentPeriodEnd) {
        await subscriptionService.syncSubscriptionStatus(token).catch(() => {});
      }

      await refreshUser().catch(() => {});
      fetchReports(pagination.current, pagination.pageSize);
    };
    syncAndFetch();

    if(update){
        setUpdate(false)
    }
  }, [update]);

  const handleTableChange = (paginationInfo) => {
    fetchReports(paginationInfo.current, paginationInfo.pageSize);
  };

  return (
    <section className="bg-white min-h-[calc(100vh-90px)] px-10 py-8">
         <div className="mb-8">
        <Title level={3} className="!m-0 !text-[#1c5a85] font-semibold">
         User records
        </Title>
        <Text className="text-gray-500 text-sm">
          Get your previous and latest pdfs here
        </Text>
      </div>

      <Card className="mb-6 rounded-xl border border-[#e8f1f7]">
        <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
          <div>
            <Text className="text-gray-500 text-sm block">Plan</Text>
            <Text strong>{user?.plan ? "Premium Monthly" : "No active plan"}</Text>
          </div>
          <div>
            <Text className="text-gray-500 text-sm block">Status</Text>
            <Tag color={subscriptionColorMap[user?.subscriptionStatus] || "default"}>
              {(user?.subscriptionStatus || "inactive").toUpperCase()}
            </Tag>
          </div>
          <div>
            <Text className="text-gray-500 text-sm block">Current Period End</Text>
            <Text>
              {user?.currentPeriodEnd
                ? new Date(user.currentPeriodEnd).toLocaleDateString()
                : "N/A"}
            </Text>
          </div>
        </div>
      </Card>

      <ProfileTable pdfs={pdfs} loading={loading} pagination={pagination} handleTableChange={handleTableChange} setUpdate={setUpdate} />
    </section>
  );
};

export default Profile;
